import {createNamespacedHelpers} from "vuex";
import {ConfigureSidebarModes} from "../enums/configureSidebarModes";
const {mapState, mapMutations} = createNamespacedHelpers('configureSidebarInterfaceStore');

export default {
  computed: {
    ...mapState([
      'interfaceMode',
      'selectedFolder',
      'selectedLink'
    ]),
  },
  methods: {
    ...mapMutations([
      'setInterfaceMode',
      'resetInterface',
    ]),
  }
}